type FormErrorProps = {
  value?: string;
};

const FormError = ({ value }: FormErrorProps) => {
  return <p className="text-red-600">{value}</p>;
};

export default FormError;
